import React, { useState } from "react";
import { providePriceForFormat } from "../../../../../server/sharedScripts/priceProviderInterpreter.js";
import IntInput from "../intInput/intInput.js";
import { describePrice } from "./priceModes.js";
import * as styles from "./IntProviderEditor.module.css";
const previewFormatName = "preview";
/**
 * Shows the price description and lets you check the price for a given order
 */
export default function PricePreview(props) {
    var _a;
    const { provider } = props;
    const [quantity, setQuantity] = useState(5);
    const [orderedBefore, setOrderedBefore] = useState(0);
    const usesCategory = typeof provider === "object" &&
        provider.type === "per-item-tiers-provider" &&
        ((_a = provider.countScope) !== null && _a !== void 0 ? _a : "line") !== "line";
    let price;
    try {
        price = providePriceForFormat(provider, {
            currentFormatName: previewFormatName,
            quantity,
            orderedFormats: [
                { name: previewFormatName, count: quantity, pricePerItem: provider },
            ],
            imageOrdersExcludedCurrentFormat: [],
            categoryItemsBefore: {
                sameFormat: orderedBefore,
                allFormats: orderedBefore,
            },
        });
    }
    catch (_b) {
        price = undefined;
    }
    return (React.createElement("div", { className: styles.preview },
        React.createElement("div", { className: styles.summary }, describePrice(provider)),
        React.createElement("div", { className: styles.calculator },
            React.createElement("span", null, "Klient zamawia"),
            React.createElement(IntInput, { state: quantity, disableExtraSpacing: true, onChange: (value) => setQuantity(Math.max(0, value)) }),
            React.createElement("span", null, "szt."),
            usesCategory && (React.createElement(React.Fragment, null,
                React.createElement("span", null, ", a wcze\u015Bniej w kategorii zam\u00F3wi\u0142"),
                React.createElement(IntInput, { state: orderedBefore, disableExtraSpacing: true, onChange: (value) => setOrderedBefore(Math.max(0, value)) }),
                React.createElement("span", null, "szt."))),
            React.createElement("span", null, "\u2192"),
            React.createElement("b", null, price === undefined ?
                "podgląd niedostępny dla tej formuły"
                : `${price} zł`))));
}
